import { graphql, useFragment } from 'react-relay';
import PropTypes from 'prop-types';
import { PRICE, PRICE_TRADE } from '../sbSharedRefineMenuConstants.ts';
import { getFilterValues, getAppliedFilter } from '../sbSharedRefineMenuHelpers.ts';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';

/* Components */
import { SbSharedRefineMenuRadioSelect } from '../../SbSharedRefineMenu/SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelect.jsx';

import dibsCss from 'dibs-css';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuPriceRanges_itemSearch on ItemSearchQueryConnection {
        displayUriRef
        appliedFilters {
            name
            canBeDismissed
            values {
                urlLabel
                linkReference
            }
        }
        filters {
            name
            values {
                linkReference
                linkable
                displayName
                urlLabel
                currency
            }
        }
    }
`;
const userFragment = graphql`
    fragment SbSharedRefineMenuPriceRanges_user on User {
        isVerifiedTrade
    }
`;

export const SbSharedRefineMenuPriceRanges = ({
    itemSearch: itemSearchRef,
    user: userRef,
    currency,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const user = useFragment(userFragment, userRef);
    const { isDesktop } = useServerVarsContext();
    const { displayUriRef = '', appliedFilters = [], filters = [] } = itemSearch;
    const isTradeUser = user?.isVerifiedTrade;
    const filterName = isTradeUser ? PRICE_TRADE : PRICE;
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    const appliedFilter = getAppliedFilter(appliedFilters, filterName);
    const priceFilterValues = getFilterValues(filters, filterName);
    const valuesToShow = priceFilterValues.filter(filter => filter.currency === currency) || [];
    const canBeDismissed = appliedFilter ? appliedFilter.canBeDismissed : true;

    return (
        <div className={isDesktop ? dibsCss.mbXsmall : null}>
            <SbSharedRefineMenuRadioSelect
                filterName={filterName}
                valuesToShow={valuesToShow}
                displayUriRef={displayUriRef}
                canBeDismissed={canBeDismissed}
                appliedFilterValues={appliedFilterValues}
                currency={currency}
                trackInputIndex
                trackingOptions={trackingOptions}
            />
        </div>
    );
};

SbSharedRefineMenuPriceRanges.propTypes = {
    user: PropTypes.object,
    itemSearch: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    trackingOptions: PropTypes.object,
};
